import _ from "lodash";
import { appSettings } from "core/config";
import { UserPermission } from "core/constants";
import { Feature } from "core/features";
import User from "core/models/user";

const featureTouserPermissionMapping = {
    [Feature.dashboard_paymentInfo]: UserPermission.balance,
    [Feature.dashboard_statements]: UserPermission.statements,
    [Feature.dashboard_clearError]: UserPermission.clearError,
    [Feature.users]: UserPermission.addUsers,
    [Feature.makePayment]: UserPermission.payAccount,
    [Feature.users_activity_log]: UserPermission.viewUserActivityLogging,
    [Feature.changePackage]: UserPermission.changePackage
}

//Note: Check user permissions too
export const isEnabled = (feature: number) => {
    const user = User.instance ?? new User("");

    const countryCode = user.countryCode;

    const key = countryCode as keyof typeof appSettings.countryOverrides;

    const countryOverrides = appSettings.countryOverrides[key]?.disabled;

    const disabledFeatures = countryOverrides ? countryOverrides : [];

    if (disabledFeatures.includes(feature)) {
        return false;
    }

    if (feature === Feature.users_activity_log && !appSettings.isEnabled.userTracking) {
        return false;
    }

    const mappedPermission = featureTouserPermissionMapping[feature];

    if (mappedPermission) {
        return user.hasPermission(mappedPermission);
    }

    return true;
}

export default isEnabled;
